/**
 * Tipos de dominio compartidos a lo largo de la aplicación.
 *
 * Convención: los tipos `Snapshot` describen el shape crudo que viene de
 * Firebase RTDB (campos opcionales, tipos defensivos). Los tipos normalizados
 * (sin sufijo) son los que consume la UI.
 */

/* === Contacto / Leads ===================================================== */

export const PRACTICES = [
  'Data, Analytics & AI',
  'Digital Consulting & Change Management',
  'Customer Engagement | CRM | Growth',
  'Technology [Innovation] Architecture',
  'No estoy seguro',
] as const;

export type Practice = (typeof PRACTICES)[number];

export interface LeadInput {
  nombre: string;
  empresa: string;
  email: string;
  telefono: string | null;
  practica: Practice;
  mensaje: string;
}

/* === Team ================================================================ */

export interface TeamMemberSnapshot {
  name?: string;
  role?: string;
  bio?: string;
  photoUrl?: string;
  linkedinUrl?: string;
  order?: number;
  active?: boolean;
}

export interface TeamMember {
  id: string;
  num: string;
  name: string;
  role: string;
  bio: string;
  photoUrl: string;
  linkedinUrl: string;
  order: number;
  active: boolean;
}

/* === Cases (Casos de éxito) ============================================== */

export interface CaseStudySnapshot {
  badge?: string;
  client?: string;
  title?: string;
  result?: string;
  stack?: string[];
  challenge?: string;
  solution?: string;
  impact?: string;
  highlights?: string[];
  illustrationIndex?: number;
  order?: number;
  active?: boolean;
}

export interface CaseStudy {
  id: string;
  badge: string;
  client: string;
  title: string;
  result: string;
  stack: string[];
  challenge: string;
  solution: string;
  impact: string;
  highlights: string[];
  illustrationIndex: number;
  order: number;
  active: boolean;
}

/* === Metrics ============================================================= */

export interface MetricSnapshot {
  value?: string | number;
  label?: string;
  prefix?: string;
  suffix?: string;
  labelNote?: string;
  order?: number;
  active?: boolean;
}

export interface Metric {
  id: string;
  value: string;
  label: string;
  prefix: string;
  suffix: string;
  labelNote: string;
  order: number;
  active: boolean;
}

/* === Certifications ====================================================== */

export interface CertificationItemSnapshot {
  name?: string;
  count?: number;
  order?: number;
}

export interface CertificationItem {
  name: string;
  count: number;
  order: number;
}

export interface ProviderCertificationsSnapshot {
  label?: string;
  total?: number;
  order?: number;
  list?: Record<string, CertificationItemSnapshot>;
}

export interface ProviderCertifications {
  label: string;
  total: number;
  order: number;
  list: CertificationItem[];
}

export type CertificationsSnapshot = Record<string, ProviderCertificationsSnapshot>;

export type CertificationsData = Record<string, ProviderCertifications>;
